export const styles = {
    expandedSkeletonContainer: {
        display: 'flex',
        alignItems: 'center',
    },
};
